import React from 'react';
import { connect } from 'react-redux';

import { getSpreadInfo } from 'redux/selectors/books';
import InfoIcon from 'components/icons/info';

import cx from 'classnames';
import styles from './styles.scss';

@connect(state => ({
  spreadInfo: getSpreadInfo(state),
}))
export default class AssignmentInstructions extends React.PureComponent {
  constructor(p) {
    super(p);
    this.state = {
      closed: p.closed === true,
    };
    this._toggle = this._toggle.bind(this);
  }

  _toggle() {
    this.setState({ closed: !this.state.closed });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.closed !== nextProps.closed) {
      this.setState({
        closed: nextProps.closed,
      });
    }
  }

  render() {
    const { className = '', spreadInfo } = this.props;
    const inspiration = spreadInfo.get('inspiration');

    const spreadLabel = spreadInfo && spreadInfo.get('label');

    return (
      <div className={className}>
        <h2>{spreadLabel}</h2>

        <div className={styles.toggle}>
          <div className={styles.circle} onClick={this._toggle}>
            <InfoIcon
              size={21}
              style={{
                fill: this.state.closed ? '#444' : '#000',
              }}
            />
          </div>
        </div>
        <div
          className={cx(styles.instructions, {
            [styles.closed]: this.state.closed,
          })}>
          <div className={styles.text}>{spreadInfo.get('assignment')}</div>
          <div className={styles.inspiration}>
            {inspiration
              ? inspiration
                  .map((insp, nr) => (
                    <div key={nr} className={styles.image}>
                      <img src={insp.getIn(['image', 'url'])} title={insp.get('label')} />
                    </div>
                  ))
                  .toArray()
              : null}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/assignment-instructions/index.js